const Contact = () => {
  return (
    <div className="flex justify-around mx-auto text-white gap-40">
      <div>
        <p className="font-custom text-3xl">Lets Chat</p>
        <p className="font-custom text-3xl">Tell me about your project</p>
        <p className="font-custom text-3xl">Lets create something Together.</p>
      </div>
      <div>
        <form>
          <div className="mb-2">
            <label className="font-custom text-lg">Send Me a Message</label>
          </div>
          <div>
            <input className="mb-2 p-2 w-72 bg-violet-700 outline-none" type="text" placeholder="Full Name" required />
          </div>
          <div>
            <input className="mb-2 p-2 bg-violet-700 w-72 outline-none" type="email" placeholder="Email" required />
          </div>
          <div>
            <input className="mb-2 p-2 bg-violet-700 w-72 outline-none" type="text" placeholder="Subject" required />
          </div>
          <h2 className="font-custom mb-2 text-lg outline-none">Your Message</h2>
          <textarea name="message" className="bg-violet-700 mb-20 outline-none p-2" rows={12} cols={40}>

          </textarea>
          <input type="submit" value="Send" />
        </form>
      </div>
    </div>
  );
}
export default Contact;
